module.exports = __webpack_public_path__ + "static/media/c4.40d5f987.jpg";